// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"550db0b6","80":"72c18063","165":"81899552","240":"6e48277a","326":"6b9d601b","450":"4da108e3","599":"52b9fe36","631":"7255a00f","641":"0ed80d20","690":"6c225694","756":"4c16f74c","851":"7357727a","965":"bb87de98"}[chunkId] + ".chunk.js";
};